const GetModulesConfigSelector = ({
  moduleConfigData: { GetModulesConfigData }
}) => GetModulesConfigData;

export default GetModulesConfigSelector;
